/* global dataLayer */

export default {
  productClick(obj, list = '') {
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: 'select_item',
      ecommerce: {
        item_list_id: list,
        item_list_name: list,
        items: [
          obj,
        ],
      },
    });
  },

  addProduct(obj) {
    dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: 'EUR',
        value: obj.price * obj.quantity,
        items: [
          obj,
        ],
      },
    });
  },

  removeProduct(obj) {
    dataLayer.push({
      event: 'remove_from_cart',
      ecommerce: {
        currency: 'EUR',
        value: obj.price * obj.quantity,
        items: [
          obj,
        ],
      },
    });
  },

  addProductToWishlist(obj) {
    dataLayer.push({
      event: 'add_to_wishlist',
      ecommerce: {
        currency: 'EUR',
        value: obj.price,
        items: [
          obj,
        ],
      },
    });
  },

  event(category, action = '(not set)', label = '(not set)', value = '(not set)') {
    dataLayer.push({
      event: 'general_event',
      general_event_category: category,
      general_event_action: action,
      general_event_label: label,
      general_event_value: value,
    });
  },
};
